import {useState,React,useEffect} from 'react'

const InputText = ({ field, handleChange, formData, errors})=>  {
      
    return (
        <div className={field.colunms}>
            <div className="form-group">
                <label>{field?.label} {field?.required ? <span className="astric">*</span> : ''}</label>

                <div className="input-bx">
                    {field?.countryCode && (
                        <span className="countryCode">
                            +{field?.countryCode}
                        </span>
                    )}
                    <input
                        autoComplete="off"
                        type={field?.type}
                        name={field?.name}
                        placeholder={field?.placeholder}
                        value={formData[field?.name] || ""}
                        required={field?.required}
                        minLength={field?.minLength}
                        maxLength={field?.maxLength}
                        onChange={handleChange}
                        className="form-control"
                        
                    />

                </div>
                {errors[field.name] && (
                    <div className="error">{errors[field?.name]}</div>
                )}
            </div>
        </div>
    )
}

export default InputText;
